{
  "_provenance": {
    "ns": "notifications",
    "source": "components/notifications/** and the in-app message_key renderings (R3-B12) (#2109 R3 lane L7)"
  },
  "admission": {
    "welcome": "You’re in. Your TRF grant is on your Grants page — TRF is setting it up now.",
    "welcomeRenewal": "Welcome back. Your renewal is approved; TRF is setting up your grant."
  },
  "announcement": {
    "published": "New from TRF: {{title}}"
  },
  "claim": {
    "needsInfo": "TRF needs more information about your reimbursement."
  },
  "grant": {
    "approved": "Your grant request was approved.",
    "awarded": "Your Signature grant has been awarded. See the amount and schedule on your Grants page.",
    "denied": "Your grant request was not approved.",
    "paid": "TRF recorded a payment on your grant. See it on your Grants page.",
    "update": "Your grant request has an update."
  },
  "poll": {
    "published": "TRF would like your input: {{title}}",
    "reminder": "A reminder from TRF: {{title}} is waiting for your answer."
  },
  "task": {
    "completed": "Your task \"{{title}}\" has been completed!"
  }
}
